import { Link } from 'react-router-dom';
import { MapPin, Facebook, Mail } from 'lucide-react';
import { churchInfo } from '../mock';

const SEAL_URL = "/images/seal.png";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-blue-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Church Info */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <img src={SEAL_URL} alt="True Love M.B.C." className="h-10 w-10 rounded-full object-cover" />
              <span className="text-2xl font-bold">{churchInfo.name}</span>
            </div>
            <div className="space-y-3 text-sm">
              <div className="flex items-start space-x-2">
                <MapPin className="h-5 w-5 text-yellow-400 flex-shrink-0 mt-0.5" />
                <span className="text-blue-100">100 E 119th St. Los Angeles CA 90061</span>
              </div>
              <div className="flex items-start space-x-2">
                <Mail className="h-5 w-5 text-yellow-400 flex-shrink-0 mt-0.5" />
                <a href="mailto:trueloveis1@att.net" className="text-blue-100 hover:text-yellow-400 transition-colors">trueloveis1@att.net</a>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-2xl font-semibold mb-4">Quick Links</h4>
            <div className="space-y-2">
              <Link to="/about" className="block text-sm text-blue-100 hover:text-yellow-400 transition-colors duration-200">
                About Us
              </Link>
              <Link to="/ministries" className="block text-sm text-blue-100 hover:text-yellow-400 transition-colors duration-200">
                Ministries
              </Link>
              <a
                href={churchInfo.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-2 text-sm text-blue-100 hover:text-yellow-400 transition-colors duration-200"
              >
                <Facebook className="h-4 w-4" />
                <span>Follow Us on Facebook</span>
              </a>
            </div>
          </div>

          {/* Zelle Donation */}
          <div>
            <h4 className="text-2xl font-semibold mb-4 text-yellow-400">Donate via Zelle</h4>
            <p className="text-blue-100 text-lg font-semibold mb-2">truelovembc</p>
            <img src="/images/zelle-qr.png" alt="Zelle QR Code" className="max-w-[140px] rounded-lg" />
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-blue-800 text-center">
          <p className="text-sm text-blue-200">
            &copy; {currentYear} {churchInfo.name}. All rights reserved.
          </p>
          <p className="text-xs text-blue-300 mt-2">
            Pastor {churchInfo.pastor}
          </p>
        </div>
      </div>
    </footer>
  );
};
